import React, { memo, useMemo } from "react";
import { STATIC_URL } from "../../constants";
import "../styles/Avatar.css";

interface AvatarProps {
  avatar?: string;
  nickname?: string;
  size?: number;
  className?: string;
}

const Avatar: React.FC<AvatarProps> = memo(
  ({ avatar, nickname, size = 40, className = "" }) => {
    const avatarUrl = useMemo(() => {
      if (!avatar) return null;
      // Check if avatar is already a full URL or just a filename
      if (avatar.startsWith("http")) {
        return avatar;
      }
      return `${STATIC_URL}${avatar.replace(/^\//, "")}`;
    }, [avatar]);

    const initial = useMemo(
      () => nickname?.charAt(0).toUpperCase() || "U",
      [nickname]
    );

    const containerStyle = useMemo(
      () => ({
        width: `${size}px`,
        height: `${size}px`,
      }),
      [size]
    );

    const placeholderStyle = useMemo(
      () => ({
        fontSize: `${size * 0.4}px`,
      }),
      [size]
    );

    return (
      <div className={`avatar ${className}`} style={containerStyle}>
        {avatarUrl ? (
          <img src={avatarUrl} alt={`${nickname}'s avatar`} />
        ) : (
          <div className="avatar-placeholder" style={placeholderStyle}>
            {initial}
          </div>
        )}
      </div>
    );
  }
);

Avatar.displayName = "Avatar";

export default Avatar;
